const STORAGE_KEY = 'wingit_aircraft_annual_check_v1';

function loadAnnualCheckMap() {
  if (typeof window === 'undefined') return {};

  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch (err) {
    return {};
  }
}

function saveAnnualCheckMap(map) {
  if (typeof window === 'undefined') return;

  try {
    const safeMap = map && typeof map === 'object' ? map : {};
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(safeMap));
  } catch (err) {
    // Ignore storage errors.
  }
}

export function getAircraftAnnualCheckDate(aircraftId) {
  const key = String(aircraftId || '').trim();
  if (!key) return '';
  const map = loadAnnualCheckMap();
  return String(map[key] || '');
}

export function setAircraftAnnualCheckDate(aircraftId, dateValue) {
  const key = String(aircraftId || '').trim();
  if (!key) return;

  const map = loadAnnualCheckMap();
  map[key] = String(dateValue || '').trim();
  saveAnnualCheckMap(map);
}
